import React from 'react';
import PropTypes from 'prop-types';

import './App.scss';
import {Widget} from './modules/widget';

const {REACT_APP_GOOGLE_API_KEY} = process.env;

const App = ({gKey}) => <Widget gKey={gKey || REACT_APP_GOOGLE_API_KEY} />;

export default App;

App.propTypes = {
  gKey: PropTypes.string,
};
